const baseUrl = "https://formly-app.fr";

export const appLinks = {
  formlyApp: "https://formly-app.fr",
  formlyCreateCourse: "https://formly-app.fr/create-course",
  legalNotices: baseUrl + "/legal/legal-notices",
  privacyPolicy: baseUrl + "/legal/privacy-policy",
  cgu: baseUrl + "/legal/cgu",
};
